// The two links in reminder emails (plan step 17):
//   /bag/restore/:token  -> restoreBag(token)   (restore-bag function)
//   /unsubscribe/:token  -> unsubscribe(token)  (unsubscribe function)

var FUNCTIONS_URL = (process.env.REACT_APP_SUPABASE_URL || '') + '/functions/v1/';
var OFFLINE = "Couldn't reach the shop. Please check your internet connection and try again.";

async function post(name, payload) {
  if (!process.env.REACT_APP_SUPABASE_URL) return { status: 0, data: { error: 'The shop isn’t connected right now. Please try again later.' } };
  try {
    var res = await fetch(FUNCTIONS_URL + name, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    var data = await res.json().catch(function() { return {}; });
    return { status: res.status, data: data || {} };
  } catch (e) {
    return { status: 0, data: { error: OFFLINE } };
  }
}

// -> { items: [{ productId, slug, variant, colour, quantity }], unavailable, alreadyPaid, error }
export async function restoreBag(token) {
  var r = await post('restore-bag', { token: token });
  if (r.status === 200 && Array.isArray(r.data.items)) {
    return {
      items: r.data.items,
      unavailable: Number(r.data.unavailable) || 0,
      alreadyPaid: r.data.alreadyPaid === true,
      error: null
    };
  }
  return { items: [], unavailable: 0, alreadyPaid: false, error: r.data.error || "Your bag couldn't be refilled. Please try again." };
}

// -> { email, error }
export async function unsubscribe(token) {
  var r = await post('unsubscribe', { token: token });
  if (r.status === 200 && r.data.ok === true) return { email: r.data.email || '', error: null };
  return { email: '', error: r.data.error || "That didn't work. Please try again." };
}

// Restore lines + the live product list -> full cart items (names and
// prices come from the shop's own product list, never from the link).
export function cartItemsFromLines(lines, products) {
  var items = [];
  var missing = 0;
  (lines || []).forEach(function(line) {
    var product = (products || []).find(function(p) {
      return String(p.id) === String(line.productId) && p.status === 'live';
    });
    if (!product || Number(product.stock) <= 0) { missing++; return; }
    var variants = product.variants || [];
    var colours = product.colours || [];
    var variant = variants.length ? variants.find(function(v) { return String(v.id) === String(line.variant); }) : null;
    var colour = colours.length ? colours.find(function(c) { return String(c.id) === String(line.colour); }) : null;
    if ((variants.length && !variant) || (colours.length && !colour)) { missing++; return; }
    items.push({
      key: product.id + '_' + (variant ? variant.id : '') + '_' + (colour ? colour.id : ''),
      productId: product.id,
      name: product.name,
      slug: product.slug,
      variantId: variant ? variant.id : null,
      variantName: variant ? variant.size_name : '',
      colourId: colour ? colour.id : null,
      colourName: colour ? colour.name : '',
      colourHex: colour ? colour.hex_code : '',
      price: variant ? variant.price : product.base_price,
      quantity: Math.max(1, Math.min(Number(line.quantity) || 1, Number(product.stock))),
      maxStock: product.stock
    });
  });
  return { items: items, missing: missing };
}
